export default __webpack_public_path__ + "static/media/avatar05.f460a1ef.svg";